import styled from "styled-components";
import { forwardRef } from "react";
import TextAnimation from "../animations/TextAnimateion";

const About = forwardRef<HTMLDivElement>((props, ref) => (
  <AboutContainer ref={ref}>
    <TextAnimation>
      <Header>About</Header>
    </TextAnimation>
    <AboutText>
      <p>
        Hello! Nice to have you here! <br></br> <br></br>I am specializing in
        front-end development, working mostly with React. I am keen to join a
        team, where I can continue to grow and contribute to exciting projects.
        I am looking for a job in Szczecin or remote. I am a quick learner,
        aiming to understand business needs and to align my skills with them. I
        am always looking for ways to improve my skills, especially in
        problem-solving, which I believe is the best way to learn. <br></br>
        <br></br> In my current/former job as a construction manager, I am
        responsible for finances, client communication, timely completion,
        quality of work and employee management. My desire to transition to a
        frontend developer role stems from my passion and interests.
      </p>
    </AboutText>
  </AboutContainer>
));

export default About;

const AboutContainer = styled.div`
  width: 100%;
  height: auto;
  margin-top: 40px;

  & > h3 {
    color: white;
    font-size: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    margin-top: 40px;
    margin-bottom: 5px;
    letter-spacing: 3px;
    font-style: oblique;
  }
`;

const Header = styled.h3`
  color: white;
  font-size: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  letter-spacing: 3px;
  font-style: oblique;

  @media (max-width: 460px) {
    margin-top: 10px;
  }
`;

const AboutText = styled.div`
  max-width: 100%;
  margin-right: 16px;
  margin-left: 20px;
  height: auto;
  border-radius: 8px;
  background: rgba(185, 185, 185, 0.44);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
  padding: 15px 15px;
  transition: all 0.1s ease;

  &:hover {
    background: rgba(36, 36, 41, 0.67);
  }
  & > p {
    background: rgba(0, 0, 0, 0.5);
    padding: 15px 15px;
    border-radius: 8px;
    text-align: justify;
  }
`;
